import React from 'react'
import { Descriptions, Table } from '@pankod/refine-antd'
import { LogicalFilter } from '@pankod/refine-core'

import { AdminPendaftaran } from '@resources/pendaftaran-diklat/types'
import useTableWithMeta from 'src/hooks/useTableWithMeta'
import { TCommonError } from 'src/interfaces/common'
import Filter, { TFilterForm } from '@components/ContentFilter'

const AdminPendaftaranTableList = () => {
  const { filters, searchFormProps, tableProps } = useTableWithMeta<
    AdminPendaftaran,
    TCommonError,
    TFilterForm<AdminPendaftaran>
  >({
    resource: 'diklat/admin-pendaftaran',
    dataProviderName: 'lms',
    onSearch: (params) => {
      const filters: LogicalFilter[] = []
      const { email, npsn } = params
      filters.push(
        {
          field: 'email',
          operator: 'eq',
          value: email,
        },
        {
          field: 'npsn',
          operator: 'eq',
          value: npsn,
        },
      )
      if (email || npsn) {
        filters.push({
          field: 't',
          operator: 'eq',
          value: new Date().getTime(),
        })
      }
      return filters
    },
  })
  return (
    <>
      <Filter
        layout="inline"
        size="small"
        formProps={searchFormProps}
        filters={filters as LogicalFilter[]}
        items={[
          {
            label: 'Email',
            name: 'email',
            placeholder: 'Cari berdasarkan email',
          },
          {
            label: 'NPSN',
            name: 'npsn',
            placeholder: 'Cari berdasarkan NPSN',
          },
        ]}
      />
      <Table
        {...tableProps}
        rowKey={'id'}
        tableLayout="fixed"
        size="small"
        scroll={{ x: 600 }}
        expandable={{
          expandedRowRender: ({ assignedPrograms, assignedProgramLocals }) => (
            <>
              <Table
                dataSource={assignedPrograms}
                rowKey={'id'}
                pagination={false}
                title={() => <strong>Daftar Program</strong>}
                size="small"
                columns={[
                  { title: 'ID', dataIndex: 'id', width: 120 },
                  { title: 'Nama Program', dataIndex: 'name' },
                ]}
              />
              <Table
                dataSource={assignedProgramLocals}
                rowKey={'id'}
                pagination={false}
                title={() => <strong>Daftar Program Lokal</strong>}
                size="small"
                className="mt-4"
                columns={[
                  { title: 'ID', dataIndex: 'id', width: 120 },
                  { title: 'Nama Program Lokal', dataIndex: 'name' },
                ]}
              />
            </>
          ),
        }}
        columns={[
          {
            title: 'ID',
            dataIndex: 'id',
            width: 100,
          },
          {
            title: 'Nama',
            dataIndex: 'nama',
            width: 200,
          },
          {
            title: 'Email',
            dataIndex: 'email',
            width: 200,
          },
          {
            title: 'NPSN',
            dataIndex: 'npsn',
            width: 150,
          },
          {
            title: 'Nama Sekolah',
            dataIndex: 'namaSekolah',
            width: 200,
          },
          {
            title: 'Wilayah',
            width: 400,
            render: (_, { provinsi, kotaKabupaten, kecamatan }) => (
              <Descriptions
                column={1}
                size="small"
                labelStyle={{ width: 120 }}
                bordered
              >
                <Descriptions.Item label="Provinsi">
                  {provinsi}
                </Descriptions.Item>
                <Descriptions.Item label="Kota/Kabupaten">
                  {kotaKabupaten}
                </Descriptions.Item>
                <Descriptions.Item label="Kecamatan">
                  {kecamatan}
                </Descriptions.Item>
              </Descriptions>
            ),
          },
        ]}
      />
    </>
  )
}

export default AdminPendaftaranTableList
